import React from "react";
import i18n from "~/assets/js/Helpers/i18n";

const MobileFooter = () => {
    return (
        <footer id="footer">
            {reactConfig.logoUrl && (
                <img
                    alt="logo"
                    src={reactConfig.logoUrl}
                    style={{ width: "80px", height: "40px" }}
                />
            )}
            <div className="footer-links">
                <a href="/impressum">{i18n.t("footer.imprint")}</a>
                <i className="fa fa-circle fa-xs" aria-hidden="true"></i>
                <a href="/datenschutz">{i18n.t("footer.dataProtection")}</a>
                <i className="fa fa-circle fa-xs" aria-hidden="true"></i>
                <a href="/agb">{i18n.t("footer.terms")}</a>
            </div>
        </footer>
    );
};

export default MobileFooter;
